<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{ $t('Login') }}</h4>
                  <p>{{ $t('Welcome Back') }}</p>
                </div>
                <vx-card>
                  <div>
                    <vs-input
                      v-validate="'required|email|min:3'"
                      data-vv-validate-on="blur"
                      name="user"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Email"
                      v-model="username"
                      class="w-full"
                    />
                    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                    <vs-input
                      data-vv-validate-on="blur"
                      v-validate="'required|min:5|max:30'"
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Password"
                      v-model="password"
                      class="w-full mt-6"
                    />
                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                    <div class="flex flex-wrap justify-between mt-5 mb-3">
                      <vs-button :disabled="!validateForm" @click="login">
                        {{$t('Login')}}
                      </vs-button>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>



<script>
export default {
  data() {
    return {
      username: 'admin@demo.com',
      password: 'abcd1234',
    };
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    }
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        this.$router.push('/')

        return false
      }
      return true
    },
    async login () {
      if (!this.checkLogin()) return

      // Loading
      this.$vs.loading()

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          username: this.username,
          password: this.password
        }
      }

      try {
        await this.$store.dispatch('auth/login', payload)
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Error',
          text: e.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  }
};
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
